export function formatCents(cents: number): string {
  const dollars = Math.round(cents) / 100;
  return Number.isInteger(dollars) ? String(dollars) : dollars.toFixed(2);
}
